// Customers
export const SETCUSTOMERSLIST = "SETCUSTOMERSLIST";
export const SETSAPCUSTOMERSLIST = "SETSAPCUSTOMERSLIST";
export const SETCONTACTPERSONSLIST = "SETCONTACTPERSONSLIST";
export const SETCUSTOMERFORMSETTINGSLIST = "SETCUSTOMERFORMSETTINGSLIST";
export const SETUSERSCUSTOMERFORMSETTINGSLIST = "SETUSERSCUSTOMERFORMSETTINGSLIST";
export const SETUNKNOWNREQUESTERLIST = "SETUNKNOWNREQUESTERLIST";
export const SET_CUSTOMER_HEADER_FILTER_VALUES = "SET_CUSTOMER_HEADER_FILTER_VALUES";

// Tickets
export const SETTICKETSLIST = "SETTICKETSLIST";
export const SETTABDETAILSTICKETSLIST = "SETTABDETAILSTICKETSLIST";
export const SETTICKETHISTORYLIST = "SETTICKETHISTORYLIST";
export const SETTICKETATTACHMENT = "SETTICKETATTACHMENT";
export const SETALLTICKETLIST = "SETALLTICKETLIST";
export const SETINSIGHTTICKETCOUNT = "SETINSIGHTTICKETCOUNT";
export const SETTABDETAILSTICKETID = "SETTABDETAILSTICKETID";
export const SETSEARCHTICKETID = "SETSEARCHTICKETID";
export const SETSEARCHSCUSTOMER = "SETSEARCHSCUSTOMER";
export const SETREQUESTORLIST = "SETREQUESTORLIST";
export const SETSERVICECALLDETAIL = "SETSERVICECALLDETAIL";
export const SETFOLLOWERSCCLIST = "SETFOLLOWERSCCLIST";
export const SETTICKETCUSTOMERLIST = "SETTICKETCUSTOMERLIST";
export const SETTICKETREQUESTERDETAIL = "SETTICKETREQUESTERDETAIL";
export const SETASSIGNEELIST = "SETASSIGNEELIST";
export const SETMACRODROPDOWNLIST = "SETMACRODROPDOWNLIST";
export const SETTICKETDETAILS = "SETTICKETDETAILS";
export const SETTICKETFORMSETTINGSLIST = "SETTICKETFORMSETTINGSLIST";
export const SETUSERSTICKETFORMSETTINGSLIST = "SETUSERSTICKETFORMSETTINGSLIST";
export const SETTICKETVIEWCOUNTLIST = "SETTICKETVIEWCOUNTLIST";
export const SETTICKETCUSTOMIZEDVIEWCOUNTLIST = "SETTICKETCUSTOMIZEDVIEWCOUNTLIST";
export const SET_EQUIPMENT_LIST = "SET_EQUIPMENT_LIST";
export const SET_PROBLEM_LIST = "SET_PROBLEM_LIST";
export const SET_SUB_PROBLEM_LIST = "SET_SUB_PROBLEM_LIST";
export const SET_TICKET_HEADER_FILTER_VALUES = "SET_TICKET_HEADER_FILTER_VALUES";
export const SETCLEARCHATS = "SETCLEARCHATS";
export const SETFOLLOWUPDATA = "SETFOLLOWUPDATA";

// Logwork
export const SETEDITORLOGWORKDATA = "SETEDITORLOGWORKDATA";
export const SETLOGWORKLIST = "SETLOGWORKLIST";
export const SETLOGWORKTICKETLIST = "SETLOGWORKTICKETLIST";
export const CLEARLOGWORKTICKETLIST = "CLEARLOGWORKTICKETLIST";
export const SETCOUNTRYLIST = "SETCOUNTRYLIST";
